import React, {useContext, useState} from 'react';
import {Form, Button, Space, Typography, Divider} from 'antd';
import {resolveItemFields} from '../detailed-item/field-descriptions';
import {PolymorphicItem} from '../../tevapi/interfaces';
import {useForm} from 'antd/es/form/Form';
import {TEVInputField} from './data-form';
import {TEVService} from '../../tevapi/io';
import {useNavigate} from 'react-router-dom';
import {TEVItemField} from '../data-rendering';
import {ComparingItemContext} from '../../contexts/items';
import {FileContext} from '../file-viewer';
import {CompareSelect} from '../detailed-item/compare-control';


interface ItemFormProps {
  item: PolymorphicItem;
};


export const ItemForm: React.FC<ItemFormProps> = (props) => {
  const fields = resolveItemFields(props.item);
  const [form] = useForm();
  const navigate = useNavigate();
  const [_, setFileUrl] = useContext(FileContext);
  const compareContext = useContext(ComparingItemContext);
  const comparison = compareContext?.comparison;

  const [waitingForServer, setWaitingForServer] = useState(false);

  const onSubmit = () => {
    const payload = form.getFieldsValue();
    setWaitingForServer(true);
    TEVService.patch(
      `/itemdata/${props.item.pk}/`,
      payload
    ).then(
      (response) => {
        if (response.status === 200) {
          // Rad, server says we're good to go.
          setWaitingForServer(false);
          navigate(`/items/${props.item.pk}/`);
        } else {
          // rip
          setWaitingForServer(false);
        }
      }
    )
    .catch(
      (reason) => {
        setWaitingForServer(false);
        console.log(reason);
      }
    );
  };

  return (
    <Form
      form={form}
      initialValues={props.item}
      layout='vertical'
      disabled={waitingForServer}
    >
      <Space direction='vertical'>
        <Space direction='horizontal'>
          <Typography.Text>
            Comparing to
          </Typography.Text>
          <CompareSelect referenceItem={props.item} />
        </Space>
        <Divider />
        <Space direction="vertical">
          {fields.map((field, i) => (
            field.readonly ? null : 
            <Space key={field.field} direction='horizontal'>
              <Form.Item
                key={`field-${i}`}
                name={field.field}
                label={field.title}
              >
                <TEVInputField
                  key={field.title}
                  field={field}
                />
              </Form.Item>
              {comparison && comparison[field.field] ?
                <>
                  <Button
                    key={`copy-${i}`}
                    onClick={
                      () => {
                        form.setFieldValue(field.field, comparison[field.field]);
                      }
                    }
                  >
                    Copy
                  </Button>
                  <TEVItemField
                    key={`field-${i}-comparison`}
                    value={comparison[field.field]}
                    row={field}
                    setFileUrl={setFileUrl}
                  />
                </>
                : null
              }
            </Space>
          ))}
        </Space>
        <Divider />
        <Space direction='horizontal'>
          <Button type="primary" onClick={onSubmit}>Submit</Button>
          <Button type="default" onClick={() => form.resetFields()}>Reset</Button>
        </Space>
      </Space>
    </Form>
  );
};
